import {
    FontWeights,
    getTheme,
    IconButton,
    IIconProps,
    IModalProps,
    mergeStyleSets,
    Modal as FluentModal
} from "@fluentui/react";
import React from "react";

type ModalSize = "md" | "lg";

export type ModalProps = React.PropsWithChildren<
    IModalProps & {
        headerText?: string;
        size?: ModalSize;
        dismissButtonDisabled?: boolean;
        onDismiss(): void;
        displayCloseButton?: boolean;
    }
>;

const mapSize = (size?: ModalSize) => {
    if (size === "lg") {
        return "70%";
    }

    return "40%";
};

export const Modal: React.FunctionComponent<ModalProps> = (props: ModalProps) => {
    const handleClose = () => {
        props.onDismiss();
    };

    const width = mapSize(props.size);

    return (
        <FluentModal
            {...props}
            styles={{
                main: { display: "flex", flexFlow: "column nowrap", alignItems: "stretch", width }
            }}
        >
            <div className={contentStyles.header}>
                <span>{props.headerText}</span>
                {props.displayCloseButton && (
                    <IconButton
                        styles={iconButtonStyles}
                        iconProps={cancelIcon}
                        ariaLabel="Close popup modal"
                        onClick={handleClose}
                        disabled={props.dismissButtonDisabled}
                    />
                )}
            </div>
            <div className={contentStyles.body}>{props.children}</div>
        </FluentModal>
    );
};
Modal.defaultProps = {
    size: "md"
};

const theme = getTheme();

const iconButtonStyles = {
    root: {
        color: theme.palette.neutralPrimary,
        marginLeft: "auto",
        marginTop: "4px",
        marginRight: "2px"
    },
    rootHovered: {
        color: theme.palette.neutralDark
    }
};
const contentStyles = mergeStyleSets({
    header: [
        theme.fonts.large,
        {
            flex: "1 1 auto",
            color: theme.palette.neutralPrimary,
            display: "flex",
            alignItems: "center",
            fontWeight: FontWeights.semibold,
            padding: "12px 12px 14px 24px"
        }
    ],
    body: {
        flex: "4 4 auto",
        padding: "0 24px 24px 24px",
        overflowY: "hidden",
        selectors: {
            p: { margin: "14px 0" },
            "p:first-child": { marginTop: 0 },
            "p:last-child": { marginBottom: 0 }
        }
    }
});
const cancelIcon: IIconProps = { iconName: "Cancel" };
